const LVPriorityLight = () => (
	<>
		<path
			d="M15.9997 28.6601C22.9916 28.6601 28.6597 22.9921 28.6597 16.0002C28.6597 9.00823 22.9916 3.34015 15.9997 3.34015C9.00779 3.34015 3.33972 9.00823 3.33972 16.0002C3.33972 22.9921 9.00779 28.6601 15.9997 28.6601Z"
			fill="white"
		/>
		<path
			d="M16.3797 6.43015L18.3197 12.3902C18.3697 12.5602 18.5297 12.6702 18.6997 12.6702H24.9697C25.3597 12.6702 25.5197 13.1702 25.2097 13.4002L20.1397 17.0902C19.9997 17.1902 19.9397 17.3701 19.9897 17.5401L21.9297 23.5002C22.0497 23.8702 21.6297 24.1802 21.3097 23.9502L16.2397 20.2602C16.0997 20.1602 15.9097 20.1602 15.7697 20.2602L10.6997 23.9502C10.3897 24.1802 9.95975 23.8702 10.0797 23.5002L12.0197 17.5401C12.0697 17.3701 12.0198 17.1902 11.8698 17.0902L6.79975 13.4002C6.48975 13.1702 6.64975 12.6702 7.03975 12.6702H13.3097C13.4797 12.6702 13.6398 12.5602 13.6898 12.3902L15.6297 6.43015C15.7497 6.06015 16.2697 6.06015 16.3897 6.43015H16.3797Z"
			fill="#2CA757"
		/>
	</>
);

export default LVPriorityLight;
